<template>
  <el-dialog
    class="item-delivery-modal"
    width="90%"
    title="发货明细"
    v-loading="loading"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="true"
  >
    <data-table :columns="columns" :list="list" />
  </el-dialog>
</template>
<script>
import ModalMixin from '@/mixins/modal/modal-mixin'
import DataTable from '@/components/DataTable'
import { OrderItemDeliveryInfo } from '../services'
import _ from 'lodash'
import moment from 'moment'
export default {
  name: 'OrderDeliveryDetailModal',
  components: { DataTable },
  mixins: [ ModalMixin ],
  data () {
    return {
      loading: false,
      list: [],
      deliveries: [],
      columns: [
        {
          name: '包裹',
          code: 'sendPackId',
          flexWidth: 1,
          cellRenderer (val) {
            return `包裹${val || ''}`
          }
        },
        {
          name: '数量',
          code: 'quantity',
          flexWidth: 1
        },
        {
          name: '时间',
          code: 'createTime',
          flexWidth: 1,
          renderFunc (val) {
            return moment(val).format('MM-DD HH:mm')
          }
        }
      ]
    }
  },
  methods: {
    init (orderItemId, deliveries) {
      this.getDeliveryInfoByOrderItem(orderItemId)
      this.deliveries = deliveries
      return this.open()
    },
    getDeliveryInfoByOrderItem (orderItemId) {
      this.loading = true
      OrderItemDeliveryInfo(orderItemId).then((ans) => {
        ans.forEach(pack => {
          const idx = _.findIndex((this.deliveries || []), o => o.id === pack.id)
          pack.sendPackId = `包裹${idx + 1}`
        })
        this.list = ans || []
      }).catch(() => {
        this.$message.error('加载包裹信息失败')
        this.close(false)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="stylus">
.item-delivery-modal
  .el-dialog
    max-width 768px
    .el-dialog__body
      padding-top 0
      max-height 640px
      overflow-x hidden
      overflow-y auto
</style>
